import React, { useState } from 'react'
import MainLayout from '../../layouts/Main'

// import { useGetUserCampuses } from '../../../hooks/campuses';
import { useExportUserJobsReportForSchool, useGetUserJobsReportForSchool } from '../../../hooks/analytics';
import { useGetStudentOnboardingResponsesOptionsByField } from '../../../hooks/misc';

import BarChart from '../../sub_components/charts/BarChart';
import FilterTable from '../../sub_components/tables/FilterTable';
import ReportDatePicker from '../../sub_components/ReportDatePicker';
import ReportTablet from '../../sub_components/ReportTablet';

import { IColumnProps, IFilterableDataProps } from '../../../interfaces/tables';
import { StudentOnboardingResponseOptionsField } from '../../../interfaces';
import { IChartData } from '../../../interfaces/charts';

const UserJobsReport = () => {
    const [campusFilters, setCampusFilters] = useState<number[]>([]); // eslint-disable-line
    const [programsOfStudyFilters, setProgramsOfStudyFilters] = useState<number[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");

    const { data: programsOfStudy } = useGetStudentOnboardingResponsesOptionsByField(StudentOnboardingResponseOptionsField.PROGRAM_OF_STUDY);

    const programsOfStudyOptions = programsOfStudy?.map((program, index) => ({
        id: index,
        name: program,
    })) ?? [];


    const filterQuery = new URLSearchParams();
    filterQuery.set("start_date", startDate);
    filterQuery.set("end_date", endDate);
    campusFilters.forEach((id) => filterQuery.append("campus_ids", id.toString()));
    programsOfStudyFilters.forEach((id) => filterQuery.append("programs_of_study", programsOfStudyOptions[id].name));

    // const { data: campuses } = useGetUserCampuses();
    const { data: userJobsReport } = useGetUserJobsReportForSchool(filterQuery.toString());
    
    const { mutate: exportCsv } = useExportUserJobsReportForSchool();
    // let filterTableDataColumns__Campuses: IColumnProps[] = [
    //     { name: "ID", identifier: "id" },
    //     { name: "Campus", identifier: "name" },
    // ];
    let filterTableDataColumns__ProgramsOfStudy: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Program of Study", identifier: "name" },
    ];
    let filterTableDataColumns__UserJobsReport: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Full Name", identifier: "full_name" },
        { name: "Email", identifier: "email" },
        { name: "Visits", identifier: "visits" },
    ];

    // let filterTableData__Campuses: IFilterableDataProps[] = [];
    let filterTableData__ProgramsOfStudy: IFilterableDataProps[] = [];
    let filterTableData__UserJobsReport: IFilterableDataProps[] = [];

    // if (campuses) {
    //     filterTableData__Campuses = campuses.map((campus) => ({
    //         id: campus.id,
    //         name: campus.name,
    //     }));
    // }

    if (programsOfStudy) {
        filterTableData__ProgramsOfStudy = programsOfStudyOptions.map((program) => ({
            id: program.id,
            name: program.name,
        }));
    }

    if (userJobsReport) {
        filterTableData__UserJobsReport = userJobsReport.table_data.map((user) => ({
            id: user.id,
            full_name: user.full_name,
            email: user.email,
            visits: user.visits,
        }));
    }

    const trimmedChartDataLabels = (data: IChartData[]): IChartData[] => {
        return data.map((item) => item.name.length > 5 ? { ...item, name: item.name.slice(0, 5) + '...' } : item);
    };

    const onExportCsv = () => {
        exportCsv({ payload: { filterQuery: filterQuery.toString() } });
    }

    return (
        <MainLayout>
            <div className='immersion__careers_report'>
                <div className='immersion__careers_report__header'>
                    <div className='immersion__careers_report__header__content'>
                        <h2 className='immersion__careers_report__header__content__title'>User Jobs Report</h2>
                        <p className='immersion__careers_report__header__content__description'>
                            This slide gives an overview of user job visits.
                        </p>
                    </div>
                    <div className='immersion__careers_report__header__actions'>
                        <button className='immersion__btn immersion__btn__primary immersion__careers_report__header__actions__button' onClick={onExportCsv}>Export CSV</button>
                    </div>
                </div>
                <div className='immersion__careers_report__chart_body'>
                    <div className='immersion__careers_report__chart__row'>
                        {/* {campuses?.length
                            ? <FilterTable
                                columns={filterTableDataColumns__Campuses}
                                data={filterTableData__Campuses}
                                filters={campusFilters}
                                setFilters={setCampusFilters}
                                enableFilters={true}
                            />
                            : <div className='immersion__careers_report__chart__no_data'>
                                No campuses found
                            </div>
                        } */}
                        {programsOfStudy?.length
                            ? <FilterTable
                                columns={filterTableDataColumns__ProgramsOfStudy}
                                data={filterTableData__ProgramsOfStudy}
                                filters={programsOfStudyFilters}
                                setFilters={setProgramsOfStudyFilters}
                                enableFilters={true}
                            />
                            : <div className='immersion__careers_report__chart__no_data'>
                                No programs of study found
                            </div>
                        }
                        <div className='immersion__careers_report__chart__row immersion__careers_report__chart__row__vertical'>
                            <ReportDatePicker
                                required={true}
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                            />
                            <ReportTablet
                                title={userJobsReport?.total_visits?.toString() ?? "0"}
                                description='Total Visits'
                                color={'green'}
                            />
                        </div>
                    </div>
                    <div className='immersion__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__UserJobsReport}
                            data={filterTableData__UserJobsReport}
                            filters={[]}
                            setFilters={() => { }}
                            enableFilters={false}
                        />
                        {userJobsReport?.job_post_chart_data.length ? (
                            <BarChart
                                data={trimmedChartDataLabels(userJobsReport?.job_post_chart_data ?? [])}
                                width={600}
                                height={318}
                                xLabel="Job Post"
                                yLabel="No. of Visits"
                                xInterval={4}
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No job visits
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default UserJobsReport;